(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cart-drawer]');
    if (!root) return;

    var overlay = root.querySelector('[data-cart-drawer-overlay]');
    var panel = root.querySelector('[data-cart-drawer-panel]');
    var sectionId = root.dataset.sectionId;
    var busy = false;
    var pendingRefresh = null;
    var lastFocus = null;
    var qtyTimer = null;

    function applyCartCount(count) {
      var n = parseInt(count, 10);
      if (isNaN(n)) return;
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = String(n);
        el.hidden = n === 0;
      });
    }

    function refreshCartCount() {
      return fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          applyCartCount(cart.item_count);
          return cart;
        })
        .catch(function () {});
    }

    function getFocusable() {
      if (!panel) return [];
      return Array.prototype.slice.call(
        panel.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter(function (el) {
        return el.offsetParent !== null || el === panel;
      });
    }

    function openDrawer() {
      lastFocus = document.activeElement;
      root.hidden = false;
      root.removeAttribute('hidden');
      if (overlay) {
        overlay.hidden = false;
        overlay.removeAttribute('hidden');
      }
      root.classList.add('is-open');
      document.body.classList.add('cart-drawer-open');
      requestAnimationFrame(function () {
        if (panel) panel.focus();
      });
    }

    function closeDrawer() {
      root.classList.remove('is-open');
      document.body.classList.remove('cart-drawer-open');
      window.setTimeout(function () {
        if (!root.classList.contains('is-open')) {
          root.hidden = true;
          if (overlay) overlay.hidden = true;
        }
      }, 280);
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }

    function refreshDrawer(options) {
      options = options || {};
      if (options.open) openDrawer();

      if (busy) {
        pendingRefresh = {
          open: !!(pendingRefresh && pendingRefresh.open) || !!options.open
        };
        return Promise.resolve();
      }

      busy = true;
      root.classList.add('is-updating');

      return fetch('/?section_id=' + encodeURIComponent(sectionId))
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshRoot = doc.querySelector('[data-cart-drawer]');
          var freshInner = freshRoot && freshRoot.querySelector('[data-cart-drawer-inner]');
          var inner = root.querySelector('[data-cart-drawer-inner]');
          if (freshInner && inner) {
            inner.innerHTML = freshInner.innerHTML;
          }
          if (freshRoot && freshRoot.dataset.sectionId) {
            sectionId = freshRoot.dataset.sectionId;
            root.dataset.sectionId = sectionId;
          }
          initUpsell();
          return refreshCartCount();
        })
        .catch(function () {})
        .finally(function () {
          busy = false;
          root.classList.remove('is-updating');
          if (options.open) openDrawer();
          var next = pendingRefresh;
          pendingRefresh = null;
          if (next) refreshDrawer(next);
        });
    }

    function changeLine(line, quantity) {
      if (busy) return;
      busy = true;
      root.classList.add('is-updating');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart update failed');
          return res.json();
        })
        .then(function (cart) {
          if (cart && typeof cart.item_count !== 'undefined') {
            applyCartCount(cart.item_count);
          }
          busy = false;
          return refreshDrawer({ open: true });
        })
        .catch(function () {
          busy = false;
          root.classList.remove('is-updating');
        });
    }

    function addUpsell(variantId, button) {
      if (busy || !variantId) return;
      busy = true;
      var original = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = button.dataset.addingText || '…';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          if (button) button.textContent = button.dataset.addedText || '✓';
          busy = false;
          return refreshDrawer({ open: true });
        })
        .catch(function () {
          if (button) {
            button.textContent = original;
            button.disabled = false;
          }
          busy = false;
          root.classList.remove('is-updating');
        });
    }

    function initUpsell() {
      var host = root.querySelector('cart-drawer-upsell');
      var wrap = root.querySelector('[data-cart-drawer-upsell]');
      if (!host) return;

      if (host.querySelector('.cart-drawer-upsell-item')) {
        if (wrap) wrap.hidden = false;
        return;
      }

      var urls = [host.dataset.urlComplementary, host.dataset.urlRelated].filter(Boolean);

      function applyFromHtml(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-drawer-upsell');
        if (!fresh) return false;
        var items = fresh.querySelectorAll('.cart-drawer-upsell-item');
        if (!items.length) return false;

        var frag = document.createElement('ul');
        frag.className = 'cart-drawer__upsell-list';
        frag.setAttribute('role', 'list');
        items.forEach(function (item) {
          frag.appendChild(item.cloneNode(true));
        });
        host.innerHTML = '';
        host.appendChild(frag);
        if (wrap) wrap.hidden = false;
        return true;
      }

      (function tryNext(i) {
        if (i >= urls.length) {
          if (wrap && !host.querySelector('.cart-drawer-upsell-item')) wrap.hidden = true;
          return;
        }
        fetch(urls[i])
          .then(function (res) { return res.text(); })
          .then(function (html) {
            if (applyFromHtml(html)) return;
            tryNext(i + 1);
          })
          .catch(function () { tryNext(i + 1); });
      })(0);
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-drawer-close]') || e.target.closest('[data-cart-drawer-overlay]')) {
        closeDrawer();
        return;
      }

      var upsellBtn = e.target.closest('[data-upsell-add]');
      if (upsellBtn) {
        e.preventDefault();
        addUpsell(upsellBtn.dataset.variantId, upsellBtn);
        return;
      }

      var row = e.target.closest('[data-cart-item]');
      if (!row) return;
      var line = parseInt(row.dataset.line, 10);
      var input = row.querySelector('[data-cart-qty-input]');
      var qty = parseInt(input && input.value, 10) || 1;

      if (e.target.closest('[data-cart-qty-minus]')) {
        changeLine(line, Math.max(0, qty - 1));
      } else if (e.target.closest('[data-cart-qty-plus]')) {
        changeLine(line, qty + 1);
      } else if (e.target.closest('[data-cart-remove]')) {
        changeLine(line, 0);
      }
    });

    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-qty-input]')) return;
      var row = e.target.closest('[data-cart-item]');
      if (!row) return;
      var qty = parseInt(e.target.value, 10);
      if (isNaN(qty) || qty < 0) qty = 1;
      window.clearTimeout(qtyTimer);
      qtyTimer = window.setTimeout(function () {
        changeLine(parseInt(row.dataset.line, 10), qty);
      }, 300);
    });

    document.addEventListener('keydown', function (e) {
      if (!root.classList.contains('is-open')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeDrawer();
        return;
      }
      if (e.key !== 'Tab' || !panel) return;
      var focusable = getFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    /* Public API — replaces header stub when present */
    var pendingOpen = window.MandarinCart && window.MandarinCart._pendingOpen;
    var api = {
      refreshCartCount: refreshCartCount,
      open: function () {
        refreshDrawer({ open: true });
      },
      close: closeDrawer,
      notifyAdded: function () {
        refreshDrawer({ open: true });
      },
      refresh: function () {
        return refreshDrawer({ open: root.classList.contains('is-open') });
      }
    };
    window.MandarinCart = api;

    document.documentElement.addEventListener('mandarin:cart:open', function () {
      api.open();
    });
    document.documentElement.addEventListener('mandarin:cart:added', function () {
      api.notifyAdded();
    });

    if (pendingOpen) api.notifyAdded();
    initUpsell();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;

    var sectionId = page.dataset.sectionId;
    var busy = false;

    /* Change a line's quantity via the Cart AJAX API, then re-render
       this whole section via the Section Rendering API so every value
       (line totals, sub-total, row removal) stays in sync — no reload. */
    function changeLine(line, quantity) {
      if (busy) return;
      busy = true;
      page.classList.add('is-updating');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart update failed');
          return fetch(window.location.pathname + '?section_id=' + sectionId);
        })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-page]');
          if (fresh) {
            page.innerHTML = fresh.innerHTML;
          }
          if (window.MandarinCart && typeof window.MandarinCart.refreshCartCount === 'function') {
            window.MandarinCart.refreshCartCount();
          } else {
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.querySelectorAll('[data-cart-count]').forEach(function (el) {
                  el.textContent = cart.item_count;
                  el.hidden = cart.item_count === 0;
                });
              })
              .catch(function () {});
          }
        })
        .catch(function () {
          /* On failure just reload — guarantees consistency */
          window.location.reload();
        })
        .finally(function () {
          busy = false;
          page.classList.remove('is-updating');
        });
    }

    /* Event delegation — survives section re-renders without rebinding */
    page.addEventListener('click', function (e) {
      var row = e.target.closest('[data-cart-item]');
      if (!row) return;
      var line = parseInt(row.dataset.line, 10);
      var input = row.querySelector('[data-cart-qty-input]');
      var qty = parseInt(input.value, 10) || 1;

      if (e.target.closest('[data-cart-qty-minus]')) {
        changeLine(line, Math.max(0, qty - 1));
      } else if (e.target.closest('[data-cart-qty-plus]')) {
        changeLine(line, qty + 1);
      } else if (e.target.closest('[data-cart-remove]')) {
        changeLine(line, 0);
      }
    });

    page.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-qty-input]')) return;
      var row = e.target.closest('[data-cart-item]');
      if (!row) return;
      var qty = parseInt(e.target.value, 10);
      if (isNaN(qty) || qty < 0) qty = 1;
      changeLine(parseInt(row.dataset.line, 10), qty);
    });

    /* Promo code / gift card "Apply" — Shopify can only redeem these at
       checkout, not on the cart page, so this carries the code to
       checkout as a ?discount= param (which Shopify auto-applies on
       arrival) rather than faking an in-page discount. */
    page.addEventListener('click', function (e) {
      var applyBtn = e.target.closest('[data-promo-code-apply]');
      if (!applyBtn) return;

      var input = applyBtn.previousElementSibling;
      var code = input && input.value.trim();
      if (!code) return;

      var checkoutLink = page.querySelector('[data-checkout-link]');
      var base = (checkoutLink && checkoutLink.getAttribute('href')) || '/checkout';
      var url = base.split('?')[0] + '?discount=' + encodeURIComponent(code);
      window.location.href = url;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    /* ── Mobile filters drawer ────────────────── */
    var filtersEl = document.querySelector('[data-collection-filters]');
    if (filtersEl) {
      var toggleBtn = document.querySelector('[data-filters-toggle]');
      var closeBtn = filtersEl.querySelector('[data-filters-close]');
      var backdrop = filtersEl.querySelector('[data-filters-backdrop]');

      function openFilters() {
        filtersEl.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }

      function closeFilters() {
        filtersEl.classList.remove('is-open');
        document.body.style.overflow = '';
      }

      if (toggleBtn) toggleBtn.addEventListener('click', openFilters);
      if (closeBtn) closeBtn.addEventListener('click', closeFilters);
      if (backdrop) backdrop.addEventListener('click', closeFilters);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && filtersEl.classList.contains('is-open')) {
          closeFilters();
        }
      });
    }

    /* ── Price range slider ───────────────────── */
    document.querySelectorAll('[data-price-slider]').forEach(function (slider) {
      var minInput = slider.querySelector('[data-price-input-min]');
      var maxInput = slider.querySelector('[data-price-input-max]');
      var minField = slider.querySelector('[data-price-field-min]');
      var maxField = slider.querySelector('[data-price-field-max]');
      var minLabel = slider.querySelector('[data-price-min-label]');
      var maxLabel = slider.querySelector('[data-price-max-label]');
      var fill = slider.querySelector('[data-price-range-fill]');
      var rangeMax = parseFloat(slider.dataset.rangeMax) || 0;
      var form = slider.closest('form');

      function formatMoney(dollars) {
        return '$' + dollars.toFixed(2);
      }

      function positionFill() {
        var minVal = parseFloat(minInput.value);
        var maxVal = parseFloat(maxInput.value);
        var minPct = rangeMax > 0 ? (minVal / rangeMax) * 100 : 0;
        var maxPct = rangeMax > 0 ? (maxVal / rangeMax) * 100 : 100;

        fill.style.left = minPct + '%';
        fill.style.right = (100 - maxPct) + '%';
      }

      /* Only touch labels/hidden fields on real user interaction — the
         server-rendered labels are penny-accurate (from price_filter.min/max_value
         in cents); this JS operates in whole-dollar slider steps and would
         otherwise clobber that precision with a rounded value on load. */
      function updateUI() {
        var minVal = parseFloat(minInput.value);
        var maxVal = parseFloat(maxInput.value);

        if (minVal > maxVal) {
          minVal = maxVal;
          minInput.value = minVal;
        }

        positionFill();

        if (minLabel) minLabel.textContent = formatMoney(minVal);
        if (maxLabel) maxLabel.textContent = formatMoney(maxVal);

        if (minField) minField.value = minVal;
        if (maxField) maxField.value = maxVal;
      }

      function onMinInput() {
        if (parseFloat(minInput.value) > parseFloat(maxInput.value)) {
          minInput.value = maxInput.value;
        }
        updateUI();
      }

      function onMaxInput() {
        if (parseFloat(maxInput.value) < parseFloat(minInput.value)) {
          maxInput.value = minInput.value;
        }
        updateUI();
      }

      minInput.addEventListener('input', onMinInput);
      maxInput.addEventListener('input', onMaxInput);

      /* Apply filter (reload with new URL params) once the user releases the handle */
      minInput.addEventListener('change', function () {
        if (form) form.submit();
      });
      maxInput.addEventListener('change', function () {
        if (form) form.submit();
      });

      positionFill();
    });

    var sortWrappers = document.querySelectorAll('[data-collection-sort]');

    sortWrappers.forEach(function (wrapper) {
      var toggle = wrapper.querySelector('[data-sort-toggle]');
      var dropdown = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!toggle || !dropdown) return;

      toggle.addEventListener('click', function () {
        var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        dropdown.setAttribute('aria-hidden', isExpanded ? 'true' : 'false');
      });

      toggle.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          toggle.setAttribute('aria-expanded', 'false');
          dropdown.setAttribute('aria-hidden', 'true');
          toggle.focus();
        }
      });

      document.addEventListener('click', function (e) {
        if (!wrapper.contains(e.target)) {
          toggle.setAttribute('aria-expanded', 'false');
          dropdown.setAttribute('aria-hidden', 'true');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["counter-timer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('flip-countdown-timer')) return;

    class FlipCountdownTimer extends HTMLElement {
      connectedCallback() {
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.units = Array.from(this.querySelectorAll('[data-unit]')).map(function (unitEl) {
          return {
            name: unitEl.getAttribute('data-unit'),
            front: unitEl.querySelector('[data-face-front]'),
            back: unitEl.querySelector('[data-face-back]'),
            flip: unitEl.querySelector('[data-digit-flip]'),
            inner: unitEl.querySelector('[data-digit-inner]'),
            lastValue: null,
            pendingHandler: null,
          };
        });

        this.completionEl = this.querySelector('[data-completion-message]');
        this.srStatus = this.querySelector('[data-sr-status]');
        this.completed = false;
        this.targetTimestamp = this.computeTarget();

        this.tick = this.tick.bind(this);
        this.tick();
        this.intervalId = window.setInterval(this.tick, 1000);
      }

      disconnectedCallback() {
        if (this.intervalId) {
          window.clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }

      computeTarget() {
        var dateStr = this.getAttribute('target-date') || '';
        var timeStr = this.getAttribute('target-time') || '00:00';
        var dateParts = dateStr.split('-').map(function (n) { return parseInt(n, 10); });
        var timeParts = timeStr.split(':').map(function (n) { return parseInt(n, 10); });
        var y = dateParts[0];
        var m = dateParts[1];
        var d = dateParts[2];

        if (!y || !m || !d) return null;

        var hh = Number.isNaN(timeParts[0]) ? 0 : timeParts[0];
        var mm = Number.isNaN(timeParts[1]) ? 0 : timeParts[1];

        return new Date(y, m - 1, d, hh, mm, 0, 0).getTime();
      }

      tick() {
        if (this.targetTimestamp === null || this.units.length === 0) return;

        var distance = this.targetTimestamp - Date.now();
        if (distance < 0) distance = 0;

        var totalSeconds = Math.floor(distance / 1000);
        var values = {
          days: Math.floor(totalSeconds / 86400),
          hours: Math.floor((totalSeconds % 86400) / 3600),
          minutes: Math.floor((totalSeconds % 3600) / 60),
          seconds: Math.floor(totalSeconds % 60),
        };

        for (var i = 0; i < this.units.length; i++) {
          var unit = this.units[i];
          this.setUnitValue(unit, values[unit.name] || 0);
        }

        if (distance === 0) {
          if (this.srStatus) {
            this.srStatus.setAttribute('aria-live', 'assertive');
            this.srStatus.textContent = 'Countdown complete';
          }
          if (!this.completed) this.handleComplete();
        } else if (values.seconds === 0 && this.srStatus) {
          this.srStatus.textContent =
            values.days + ' days ' + values.hours + ' hours ' + values.minutes + ' minutes remaining';
        }
      }

      setUnitValue(unit, value) {
        var formatted = String(Math.max(0, value)).padStart(2, '0');
        if (unit.lastValue === formatted) return;

        var isFirstRender = unit.lastValue === null;
        unit.lastValue = formatted;

        if (!unit.front || !unit.back || !unit.flip || !unit.inner || this.reducedMotion || isFirstRender) {
          if (unit.front) unit.front.textContent = formatted;
          if (unit.back) unit.back.textContent = formatted;
          return;
        }

        var inner = unit.inner;
        var flip = unit.flip;

        // A previous flip may still be mid-transition if a tick lands late (tab throttling,
        // slow devices). Finish it synchronously (not via the rAF-deferred path) so its
        // transition is fully re-armed before we start the next flip below.
        if (unit.pendingHandler) {
          inner.removeEventListener('transitionend', unit.pendingHandler);
          unit.pendingHandler(null, true);
        }

        unit.back.textContent = formatted;
        flip.classList.add('is-flipping');

        var onEnd = function (event, sync) {
          if (!sync && (!event || event.target !== inner || event.propertyName !== 'transform')) return;
          inner.removeEventListener('transitionend', onEnd);
          unit.pendingHandler = null;
          unit.front.textContent = formatted;
          flip.classList.add('is-resetting');
          void inner.offsetHeight;
          flip.classList.remove('is-flipping');
          if (sync) {
            void inner.offsetHeight;
            flip.classList.remove('is-resetting');
          } else {
            requestAnimationFrame(function () {
              flip.classList.remove('is-resetting');
            });
          }
        };
        unit.pendingHandler = onEnd;
        inner.addEventListener('transitionend', onEnd);
      }

      handleComplete() {
        this.completed = true;
        if (this.intervalId) {
          window.clearInterval(this.intervalId);
          this.intervalId = null;
        }
        this.setAttribute('data-complete', 'true');
        if (this.completionEl) this.completionEl.hidden = false;
        this.dispatchEvent(new CustomEvent('countdown:complete', { bubbles: true }));
      }
    }

    customElements.define('flip-countdown-timer', FlipCountdownTimer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaqAccordion() {
      document.querySelectorAll('.faq-accordion__item').forEach(function (item) {
        var trigger = item.querySelector('.faq-accordion__trigger');
        var answer = item.querySelector('.faq-accordion__answer');
        if (!trigger || !answer) return;

        trigger.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');

          if (isOpen) {
            answer.style.maxHeight = answer.scrollHeight + 'px';
            answer.getBoundingClientRect();
            item.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
            answer.setAttribute('aria-hidden', 'true');
            answer.style.maxHeight = '0';
          } else {
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            answer.setAttribute('aria-hidden', 'false');
            answer.style.maxHeight = answer.scrollHeight + 'px';

            answer.addEventListener('transitionend', function onTransitionEnd(e) {
              if (e.propertyName !== 'max-height') return;
              if (item.classList.contains('is-open')) {
                answer.style.maxHeight = 'none';
              }
              answer.removeEventListener('transitionend', onTransitionEnd);
            });
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFaqAccordion);
    } else {
      initFaqAccordion();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* ────────────────────────────────────────────────────────────────
       InfiniteCarousel — pure vanilla JS drag carousel
       • No external libraries
       • transform: translateX() — NO scrollLeft
       • Mouse drag with momentum / snap
       • Touch swipe with momentum / snap (prevents vertical scroll only when horizontal drag > 10px)
       • Optional infinite loop (data-loop="true"): clones first/last N cards
         for seamless looping. With data-loop="false" the carousel stops at
         both ends and the last card sits flush with the right edge.
       • Resize-safe (recalculates offsets without artifacts)
    ──────────────────────────────────────────────────────────────── */

    var TRANSITION = 'transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    var VELOCITY_THRESHOLD = 0.18; /* px/ms — soft flick advances a card */
    var DRAG_CLICK_THRESHOLD = 6;  /* px — above this, treat as drag not click */
    var SNAP_RATIO = 0.18;         /* displace ≥18% of card step → advance */
    var CLONE_COUNT = 3;           /* clone this many cards at each end */

    function InfiniteCarousel(el) {
      this.el    = el;
      this.track = el.querySelector('.featured-products__track');

      if (!this.track) return;

      /* Loop setting from schema (defaults to on if attribute missing) */
      this.loop = el.dataset.loop !== 'false';

      /* Collect original items */
      this.origItems = Array.from(this.track.querySelectorAll('.featured-products__item'));
      this.origCount = this.origItems.length;
      if (this.origCount === 0) return;

      this.cloneCount = this.loop ? Math.min(CLONE_COUNT, this.origCount) : 0;

      /* Build clones (loop mode only) */
      if (this.loop) this._insertClones();

      /* All items after cloning */
      this.allItems = Array.from(this.track.querySelectorAll('.featured-products__item'));

      /* State */
      this.isDragging    = false;
      this.isHorizontal  = false;
      this.hasDragged    = false;
      this.suppressClick = false;
      this.startX        = 0;
      this.startY        = 0;
      this.startTime     = 0;
      this.prevX         = 0;
      this.velocity      = 0;
      this.prevTranslate = 0;
      this.currentTranslate = 0;

      /* Start at first real card (after leading clones; 0 when loop is off) */
      this.currentIndex = this.cloneCount;

      /* Set initial position silently */
      this._setTranslate(this._offsetForIndex(this.currentIndex), false);

      /* Arrow buttons (optional, rendered when show_arrows schema setting is true) */
      this.prevBtn = el.querySelector('[data-carousel-prev]');
      this.nextBtn = el.querySelector('[data-carousel-next]');

      this._onMouseDown  = this._onMouseDown.bind(this);
      this._onMouseMove  = this._onMouseMove.bind(this);
      this._onMouseUp    = this._onMouseUp.bind(this);
      this._onTouchStart = this._onTouchStart.bind(this);
      this._onTouchMove  = this._onTouchMove.bind(this);
      this._onTouchEnd   = this._onTouchEnd.bind(this);
      this._onClickCapture = this._onClickCapture.bind(this);
      this._onTransEnd   = this._onTransEnd.bind(this);
      this._onResize     = this._onResize.bind(this);

      this.track.addEventListener('mousedown',    this._onMouseDown);
      window.addEventListener('mousemove',        this._onMouseMove);
      window.addEventListener('mouseup',          this._onMouseUp);
      this.track.addEventListener('touchstart',   this._onTouchStart, { passive: true });
      this.track.addEventListener('touchmove',    this._onTouchMove,  { passive: false });
      this.track.addEventListener('touchend',     this._onTouchEnd);
      this.track.addEventListener('click',        this._onClickCapture, true);
      this.track.addEventListener('transitionend',this._onTransEnd);
      window.addEventListener('resize',           this._onResize);

      /* Arrow button click handlers */
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function () {
          this._goTo(this.currentIndex - 1);
        }.bind(this));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function () {
          this._goTo(this.currentIndex + 1);
        }.bind(this));
      }

      /* Prevent drag of images/links inside track */
      this.track.addEventListener('dragstart', function(e){ e.preventDefault(); });

      /* Initial arrow state */
      this._updateArrows();
    }

    /* ── DOM helpers ─────────────────────────── */

    InfiniteCarousel.prototype._insertClones = function () {
      var n = this.cloneCount;
      var count = this.origCount;

      /* Prepend clones of last N originals (in reverse so order is maintained) */
      for (var i = count - 1; i >= count - n; i--) {
        var clone = this.origItems[i].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.classList.add('fp-clone');
        this.track.insertBefore(clone, this.track.firstChild);
      }

      /* Append clones of first N originals */
      for (var j = 0; j < n; j++) {
        var clone2 = this.origItems[j].cloneNode(true);
        clone2.setAttribute('aria-hidden', 'true');
        clone2.classList.add('fp-clone');
        this.track.appendChild(clone2);
      }
    };

    InfiniteCarousel.prototype._cardWidth = function () {
      var item = this.allItems[0];
      return item ? item.offsetWidth : 391;
    };

    InfiniteCarousel.prototype._gap = function () {
      return parseFloat(getComputedStyle(this.track).gap) || 40;
    };

    /* Max scroll distance (px) when loop is off — last card flush right */
    InfiniteCarousel.prototype._maxScroll = function () {
      var step = this._cardWidth() + this._gap();
      return Math.max(0, this.allItems.length * step - this._gap() - this.track.clientWidth);
    };

    /* Highest reachable index when loop is off */
    InfiniteCarousel.prototype._maxIndex = function () {
      var step = this._cardWidth() + this._gap();
      return Math.max(0, Math.ceil(this._maxScroll() / step - 0.01));
    };

    InfiniteCarousel.prototype._offsetForIndex = function (idx) {
      var step = this._cardWidth() + this._gap();
      var x = idx * step;
      if (!this.loop) x = Math.min(x, this._maxScroll());
      return -x;
    };

    InfiniteCarousel.prototype._setTranslate = function (x, animate) {
      this.currentTranslate = x;
      this.track.style.transition = animate ? TRANSITION : 'none';
      this.track.style.transform  = 'translateX(' + x + 'px)';
    };

    InfiniteCarousel.prototype._goTo = function (idx) {
      var max = this.loop ? this.allItems.length - 1 : this._maxIndex();
      idx = Math.max(0, Math.min(idx, max));
      this.currentIndex = idx;
      this._setTranslate(this._offsetForIndex(idx), true);
      this._updateArrows();
    };

    /* ── Arrow state ─────────────────────────── */

    InfiniteCarousel.prototype._updateArrows = function () {
      if (!this.prevBtn && !this.nextBtn) return;

      /* Loop mode: both arrows always available */
      if (this.loop) {
        if (this.prevBtn) this.prevBtn.classList.remove('fp-hidden');
        if (this.nextBtn) this.nextBtn.classList.remove('fp-hidden');
        return;
      }

      /* No loop: hide prev at start, next at end */
      var max = this._maxIndex();
      if (this.prevBtn) this.prevBtn.classList.toggle('fp-hidden', this.currentIndex <= 0);
      if (this.nextBtn) this.nextBtn.classList.toggle('fp-hidden', this.currentIndex >= max);
    };

    /* ── Snap & infinite loop ────────────────── */

    InfiniteCarousel.prototype._snapToCard = function () {
      var cardStep  = this._cardWidth() + this._gap();
      var total     = this.allItems.length;
      var dx        = this.currentTranslate - this.prevTranslate;
      var targetIdx;

      if (Math.abs(this.velocity) > VELOCITY_THRESHOLD) {
        /* Momentum: advance one card in swipe direction */
        targetIdx = this.velocity < 0
          ? this.currentIndex + 1
          : this.currentIndex - 1;
      } else if (Math.abs(dx) > cardStep * SNAP_RATIO) {
        /* Soft threshold: short swipe still advances without edge-to-edge drag */
        targetIdx = dx < 0
          ? this.currentIndex + 1
          : this.currentIndex - 1;
      } else {
        /* Snap to nearest */
        var raw = -this.currentTranslate / cardStep;
        targetIdx = Math.round(raw);
      }

      /* Clamp: full item range in loop mode, visible range otherwise */
      var maxIdx = this.loop ? total - 1 : this._maxIndex();
      targetIdx = Math.max(0, Math.min(targetIdx, maxIdx));
      this.currentIndex = targetIdx;
      this._setTranslate(this._offsetForIndex(this.currentIndex), true);
    };

    InfiniteCarousel.prototype._onTransEnd = function () {
      if (!this.loop) return; /* no clone jumping when loop is off */

      var realStart = this.cloneCount;
      var realEnd   = this.cloneCount + this.origCount - 1;
      var idx       = this.currentIndex;

      /* Went past trailing clones → jump to matching real card */
      if (idx > realEnd) {
        this.currentIndex = realStart + (idx - realEnd - 1);
        this._setTranslate(this._offsetForIndex(this.currentIndex), false);
      }
      /* Went before leading clones → jump to matching real card */
      else if (idx < realStart) {
        this.currentIndex = realEnd - (realStart - idx - 1);
        this._setTranslate(this._offsetForIndex(this.currentIndex), false);
      }
    };

    /* ── Click suppression (drag must not open product links) ── */

    InfiniteCarousel.prototype._onClickCapture = function (e) {
      if (!this.suppressClick) return;
      e.preventDefault();
      e.stopPropagation();
      this.suppressClick = false;
    };

    InfiniteCarousel.prototype._armClickSuppress = function () {
      var self = this;
      this.suppressClick = true;
      /* Clear if the browser never fires click after a drag */
      clearTimeout(this._suppressTimer);
      this._suppressTimer = setTimeout(function () {
        self.suppressClick = false;
      }, 50);
    };

    /* ── Mouse events ─────────────────────── */

    InfiniteCarousel.prototype._onMouseDown = function (e) {
      if (e.button !== 0) return; /* only left mouse button */
      this.isDragging    = true;
      this.hasDragged    = false;
      this.suppressClick = false;
      this.startX        = e.clientX;
      this.prevX         = e.clientX;
      this.startTime     = Date.now();
      this.velocity      = 0;
      this.prevTranslate = this.currentTranslate;
      this.track.style.transition = 'none';
      this.track.classList.add('is-dragging');
      e.preventDefault();
    };

    InfiniteCarousel.prototype._onMouseMove = function (e) {
      if (!this.isDragging) return;
      var dx      = e.clientX - this.startX;
      var elapsed = Date.now() - this.startTime;
      if (Math.abs(dx) > DRAG_CLICK_THRESHOLD) this.hasDragged = true;
      this.velocity = elapsed > 0 ? (e.clientX - this.prevX) / elapsed : 0;
      this.prevX    = e.clientX;
      this._setTranslate(this.prevTranslate + dx, false);
    };

    InfiniteCarousel.prototype._onMouseUp = function () {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.track.classList.remove('is-dragging');
      if (this.hasDragged) this._armClickSuppress();
      this._snapToCard();
      this._updateArrows();
    };

    /* ── Touch events ─────────────────────── */

    InfiniteCarousel.prototype._onTouchStart = function (e) {
      var t         = e.touches[0];
      this.isDragging   = true;
      this.isHorizontal = false;
      this.hasDragged   = false;
      this.suppressClick = false;
      this.startX       = t.clientX;
      this.startY       = t.clientY;
      this.prevX        = t.clientX;
      this.startTime    = Date.now();
      this.velocity     = 0;
      this.prevTranslate = this.currentTranslate;
      this.track.style.transition = 'none';
    };

    InfiniteCarousel.prototype._onTouchMove = function (e) {
      if (!this.isDragging) return;
      var t  = e.touches[0];
      var dx = t.clientX - this.startX;
      var dy = t.clientY - this.startY;

      /* Determine axis on first significant movement */
      if (!this.isHorizontal && Math.abs(dx) > 10) {
        this.isHorizontal = Math.abs(dx) > Math.abs(dy);
      }

      if (this.isHorizontal) {
        e.preventDefault(); /* block vertical page scroll */
        if (Math.abs(dx) > DRAG_CLICK_THRESHOLD) this.hasDragged = true;
        var elapsed   = Date.now() - this.startTime;
        this.velocity = elapsed > 0 ? (t.clientX - this.prevX) / elapsed : 0;
        this.prevX    = t.clientX;
        this._setTranslate(this.prevTranslate + dx, false);
      }
    };

    InfiniteCarousel.prototype._onTouchEnd = function () {
      if (!this.isDragging) return;
      this.isDragging = false;
      if (this.isHorizontal) {
        if (this.hasDragged) this._armClickSuppress();
        this._snapToCard();
        this._updateArrows();
      }
    };

    /* ── Resize ───────────────────────────── */

    InfiniteCarousel.prototype._onResize = function () {
      /* Keep index within reachable range when loop is off */
      if (!this.loop) {
        this.currentIndex = Math.min(this.currentIndex, this._maxIndex());
      }
      /* Silently recalculate position using new card dimensions */
      this._setTranslate(this._offsetForIndex(this.currentIndex), false);
      this._updateArrows();
    };

    /* ── Init ─────────────────────────────── */

    document.querySelectorAll('[data-carousel]').forEach(function (el) {
      /* product-recommendations elements fetch their own content async
         (see customElements.define below) — they init the carousel
         themselves once that content lands. */
      if (el.tagName.toLowerCase() === 'product-recommendations') return;
      new InfiniteCarousel(el);
    });

    /* ── Dynamic "You may also like" recommendations ─────────
       Shopify only populates the `recommendations` Liquid object on a
       dedicated recommendations request, not a normal page load — so
       real usage requires fetching that endpoint client-side and
       swapping in the returned markup. */
    if (window.customElements && !customElements.get('product-recommendations')) {
      class ProductRecommendations extends HTMLElement {
        connectedCallback() {
          var url = this.dataset.url;
          if (!url) return;

          fetch(url)
            .then(function (res) { return res.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var newContent = doc.querySelector('product-recommendations');
              if (!newContent || !newContent.innerHTML.trim()) return;
              /* Replace with fetched markup (track + shared arrows) then
                 reuse the same InfiniteCarousel as homepage Featured Products.
                 data-loop stays on this outer element, so the setting carries over. */
              this.innerHTML = newContent.innerHTML;
              if (this.querySelector('.featured-products__track')) {
                new InfiniteCarousel(this);
              }
            }.bind(this))
            .catch(function () { /* leave empty on failure */ });
        }
      }
      customElements.define('product-recommendations', ProductRecommendations);
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;

    var menuToggle = header.querySelector('[data-header-menu-toggle]');
    var nav = header.querySelector('[data-header-nav]');
    var backdrop = document.querySelector('[data-header-backdrop]');
    var dropdownToggles = header.querySelectorAll('.site-header__menu-link--has-dropdown');

    /* ── Homepage-only: transparent-over-hero → solid on scroll ── */
    if (header.hasAttribute('data-header-home')) {
      var SCROLL_THRESHOLD = 80;
      var ticking = false;

      function updateHeaderState() {
        header.classList.toggle('is-scrolled', window.scrollY > SCROLL_THRESHOLD);
        ticking = false;
      }

      updateHeaderState(); /* correct state on load if page opens mid-scroll */

      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateHeaderState);
      }, { passive: true });
    }

    /* ── Mobile slide-in nav ─────────────────── */
    function openMobileNav() {
      nav.classList.add('is-open');
      menuToggle.setAttribute('aria-expanded', 'true');
      menuToggle.setAttribute('aria-label', menuToggle.dataset.labelClose || 'Close menu');
      if (backdrop) {
        backdrop.hidden = false;
        requestAnimationFrame(function () { backdrop.classList.add('is-visible'); });
      }
      document.body.style.overflow = 'hidden';
    }

    function closeMobileNav() {
      nav.classList.remove('is-open');
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.setAttribute('aria-label', menuToggle.dataset.labelOpen || 'Open menu');
      if (backdrop) {
        backdrop.classList.remove('is-visible');
        backdrop.hidden = true;
      }
      document.body.style.overflow = '';
    }

    if (menuToggle && nav) {
      menuToggle.addEventListener('click', function () {
        var isOpen = nav.classList.contains('is-open');
        if (isOpen) { closeMobileNav(); } else { openMobileNav(); }
      });

      if (backdrop) {
        backdrop.addEventListener('click', closeMobileNav);
      }

      nav.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', closeMobileNav);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && nav.classList.contains('is-open')) {
          closeMobileNav();
          menuToggle.focus();
        }
      });
    }

    /* ── Desktop dropdowns ────────────────────── */
    dropdownToggles.forEach(function (toggle) {
      var dropdown = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!dropdown) return;

      toggle.addEventListener('click', function () {
        var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

        dropdownToggles.forEach(function (other) {
          if (other !== toggle) {
            other.setAttribute('aria-expanded', 'false');
            var otherDrop = document.getElementById(other.getAttribute('aria-controls'));
            if (otherDrop) otherDrop.setAttribute('aria-hidden', 'true');
          }
        });

        toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        dropdown.setAttribute('aria-hidden', isExpanded ? 'true' : 'false');
      });

      toggle.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          toggle.setAttribute('aria-expanded', 'false');
          dropdown.setAttribute('aria-hidden', 'true');
          toggle.focus();
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) {
        dropdownToggles.forEach(function (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
          var drop = document.getElementById(toggle.getAttribute('aria-controls'));
          if (drop) drop.setAttribute('aria-hidden', 'true');
        });
      }
    });

    /* ── Cart icon opens slide-out drawer (cart-drawer section) ── */
    var cartIcon = header.querySelector('[data-cart-icon]');
    if (cartIcon) {
      cartIcon.addEventListener('click', function (e) {
        if (window.MandarinCart && typeof window.MandarinCart.open === 'function') {
          e.preventDefault();
          window.MandarinCart.open();
        }
      });
    }

    /* Stub until cart-drawer JS registers the full API */
    if (!window.MandarinCart) {
      window.MandarinCart = {
        _pendingOpen: false,
        notifyAdded: function () {
          this._pendingOpen = true;
          document.documentElement.dispatchEvent(new CustomEvent('mandarin:cart:added'));
        },
        open: function () {
          this._pendingOpen = true;
          document.documentElement.dispatchEvent(new CustomEvent('mandarin:cart:open'));
        },
        refreshCartCount: function () {
          return fetch('/cart.js')
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count]').forEach(function (el) {
                el.textContent = cart.item_count;
                el.hidden = cart.item_count === 0;
              });
              return cart;
            })
            .catch(function () {});
        }
      };
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var MOBILE_QUERY = '(max-width: 749px)';

    function initHeroVideo(video) {
      if (!video || video.getAttribute('data-hero-video-init') === 'true') return;
      video.setAttribute('data-hero-video-init', 'true');

      /* Reduced motion or Data Saver: keep the poster image, download nothing. */
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var conn = navigator.connection;
      if (reduceMotion || (conn && conn.saveData)) return;

      var isMobile = window.matchMedia && window.matchMedia(MOBILE_QUERY).matches;
      var mobileSrc = video.getAttribute('data-mobile-src');
      var desktopSrc = video.getAttribute('data-desktop-src');
      var src = isMobile && mobileSrc ? mobileSrc : desktopSrc;
      if (!src) return;

      video.muted = true; /* Safari checks the property, not just the attribute */
      video.src = src;
      video.load();

      video.addEventListener('playing', function () {
        video.classList.add('is-ready');
      }, { once: true });

      var played = video.play();
      if (played && typeof played.catch === 'function') {
        played.catch(function () { /* autoplay blocked — poster image stays */ });
      }
    }

    function initAll(root) {
      var scope = root || document;
      var videos = scope.querySelectorAll('[data-hero-video]');
      for (var i = 0; i < videos.length; i++) initHeroVideo(videos[i]);
    }

    /* Defer the video fetch until the LCP poster image has landed. */
    if (document.readyState === 'complete') {
      initAll();
    } else {
      window.addEventListener('load', function () { initAll(); }, { once: true });
    }

    /* Theme editor re-renders the section without re-running this block. */
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function CollectionCarousel(el) {
      this.el        = el;
      this.wrapper   = el.querySelector('.oc-track-wrapper');
      this.track     = el.querySelector('.oc-track');
      this.prevBtn   = el.querySelector('.oc-btn--prev');
      this.nextBtn   = el.querySelector('.oc-btn--next');

      if (!this.track || !this.wrapper) return;

      this._items        = [];
      this._clonesBefore = 0;
      this._clonesAfter  = 0;
      this._current      = 0;
      this._offset       = 0;
      this._transitioning = false;

      /* drag/swipe state */
      this._drag = {
        active: false,
        startX: 0,
        startY: 0,
        currentX: 0,
        velocityX: 0,
        lastX: 0,
        lastTime: 0,
        isHoriz: null,
      };

      this._init();
    }

    CollectionCarousel.prototype._init = function () {
      var self = this;

      this._buildClones();
      this._updateItemWidth();
      this._goTo(this._clonesBefore, false);

      /* arrow clicks */
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function () { self.nudge(-1); });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function () { self.nudge(1); });
      }

      /* mouse drag */
      this.track.addEventListener('mousedown', function (e) { self._onDragStart(e.clientX, e.clientY, e); });
      window.addEventListener('mousemove', function (e) { self._onDragMove(e.clientX, e.clientY); });
      window.addEventListener('mouseup',   function (e) { self._onDragEnd(); });

      /* touch swipe */
      this.track.addEventListener('touchstart', function (e) {
        var t = e.touches[0];
        self._onDragStart(t.clientX, t.clientY, e);
      }, { passive: true });
      this.track.addEventListener('touchmove', function (e) {
        var t = e.touches[0];
        if (self._drag.isHoriz === null) {
          var dx = Math.abs(t.clientX - self._drag.startX);
          var dy = Math.abs(t.clientY - self._drag.startY);
          if (dx > 10 || dy > 10) {
            self._drag.isHoriz = dx > dy;
          }
        }
        if (self._drag.isHoriz) {
          e.preventDefault();
          self._onDragMove(t.clientX, t.clientY);
        }
      }, { passive: false });
      this.track.addEventListener('touchend', function () { self._onDragEnd(); });

      /* responsive: rebuild on resize */
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function () {
          self._updateItemWidth();
          self._goTo(self._current, false);
        });
        ro.observe(this.wrapper);
      }

      /* loop jump after CSS transition ends */
      this.track.addEventListener('transitionend', function () {
        self._transitioning = false;
        self._loopJump();
      });
    };

    CollectionCarousel.prototype._visibleCount = function () {
      var ww = this.wrapper.offsetWidth;
      var iw = this._itemWidth();
      var gap = this._gap();
      return Math.max(1, Math.round(ww / (iw + gap)));
    };

    CollectionCarousel.prototype._itemWidth = function () {
      var firstItem = this.track.querySelector('.oc-item');
      return firstItem ? firstItem.offsetWidth : 0;
    };

    CollectionCarousel.prototype._gap = function () {
      return parseInt(getComputedStyle(this.track).gap) || 14;
    };

    CollectionCarousel.prototype._buildClones = function () {
      var realItems = Array.from(this.track.querySelectorAll('.oc-item:not(.oc-item--clone)'));
      if (realItems.length === 0) return;

      /* remove any existing clones */
      this.track.querySelectorAll('.oc-item--clone').forEach(function (c) { c.parentNode.removeChild(c); });

      var n = realItems.length;

      /* clone last N at start, first N at end */
      for (var i = n - 1; i >= 0; i--) {
        var c = realItems[i].cloneNode(true);
        c.classList.add('oc-item--clone');
        c.setAttribute('aria-hidden', 'true');
        this.track.insertBefore(c, this.track.firstChild);
      }
      for (var j = 0; j < n; j++) {
        var c2 = realItems[j].cloneNode(true);
        c2.classList.add('oc-item--clone');
        c2.setAttribute('aria-hidden', 'true');
        this.track.appendChild(c2);
      }

      this._clonesBefore = n;
      this._clonesAfter  = n;
      this._current      = n; /* start at first real item */
      this._items        = Array.from(this.track.querySelectorAll('.oc-item'));
    };

    CollectionCarousel.prototype._updateItemWidth = function () {
      /* width is set by CSS calc, nothing needed — items flex sizing handles it */
    };

    CollectionCarousel.prototype._offsetFor = function (index) {
      var iw  = this._itemWidth();
      var gap = this._gap();
      return index * (iw + gap);
    };

    CollectionCarousel.prototype._applyOffset = function (offset, animate) {
      this._offset = offset;
      if (animate) {
        this.track.classList.add('is-animating');
        this._transitioning = true;
      } else {
        this.track.classList.remove('is-animating');
      }
      this.track.style.transform = 'translateX(' + (-offset) + 'px)';
    };

    CollectionCarousel.prototype._goTo = function (index, animate) {
      this._current = index;
      this._applyOffset(this._offsetFor(index), !!animate);
    };

    CollectionCarousel.prototype._loopJump = function () {
      var realCount = this._items.length - this._clonesBefore - this._clonesAfter;
      var firstReal = this._clonesBefore;
      var lastReal  = this._clonesBefore + realCount - 1;

      if (this._current < firstReal) {
        /* jumped into before-clones: silently move to the corresponding real item */
        var target = this._current + realCount;
        this._goTo(target, false);
      } else if (this._current > lastReal) {
        /* jumped into after-clones: silently move to the corresponding real item */
        var target2 = this._current - realCount;
        this._goTo(target2, false);
      }
    };

    CollectionCarousel.prototype.nudge = function (dir) {
      if (this._transitioning) return;
      this._goTo(this._current + dir, true);
    };

    /* ── Drag helpers ─── */
    CollectionCarousel.prototype._onDragStart = function (x, y, e) {
      this._drag.active    = true;
      this._drag.startX    = x;
      this._drag.startY    = y;
      this._drag.currentX  = x;
      this._drag.lastX     = x;
      this._drag.lastTime  = Date.now();
      this._drag.velocityX = 0;
      this._drag.isHoriz   = null;

      this.track.classList.add('is-dragging');
      this.track.classList.remove('is-animating');
      this._transitioning = false;
    };

    CollectionCarousel.prototype._onDragMove = function (x) {
      if (!this._drag.active) return;

      var dx       = x - this._drag.lastX;
      var now      = Date.now();
      var dt       = Math.max(1, now - this._drag.lastTime);
      this._drag.velocityX = dx / dt;
      this._drag.lastX     = x;
      this._drag.lastTime  = now;
      this._drag.currentX  = x;

      var totalDx = x - this._drag.startX;
      this.track.style.transform = 'translateX(' + (-this._offset + totalDx) + 'px)';
    };

    CollectionCarousel.prototype._onDragEnd = function () {
      if (!this._drag.active) return;
      this._drag.active = false;
      this.track.classList.remove('is-dragging');

      var totalDx   = this._drag.currentX - this._drag.startX;
      var velocity  = this._drag.velocityX;
      var iw        = this._itemWidth();
      var threshold = iw * 0.25;

      if (Math.abs(velocity) > 0.3 || Math.abs(totalDx) > threshold) {
        var dir = totalDx < 0 ? 1 : -1;
        this._goTo(this._current + dir, true);
      } else {
        /* snap back to current */
        this._applyOffset(this._offsetFor(this._current), true);
      }
    };

    /* ── Bootstrap ─── */
    document.querySelectorAll('[data-oc-carousel]').forEach(function (el) {
      new CollectionCarousel(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    

  (function () {

     setInterval(function () {
         const backInStockButton = document.querySelector('.timesact-backInStock-button');
           const buyNowButton = document.querySelector('.product-info__add-to-cart');

           if (!backInStockButton) return;

           if (backInStockButton) {
               buyNowButton.style.display = '';
           } 
       }, 100);
    var main = document.querySelector('[data-product-main]');
    if (!main) return;

    /* ── Gallery: thumbnail click swaps main image ── */
    var mainImg = main.querySelector('[data-gallery-main]');
    var thumbs = main.querySelectorAll('[data-gallery-thumb]');
    var thumbDragMoved = false;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        if (thumbDragMoved) {
          e.preventDefault();
          return;
        }
        if (!mainImg) return;
        mainImg.src = thumb.dataset.imageSrc;
        mainImg.srcset = '';
        mainImg.alt = thumb.dataset.imageAlt || '';
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    /* ── Gallery: chevron scrolls thumbnail strip ── */
    var moreBtn = main.querySelector('[data-gallery-more]');
    var thumbList = main.querySelector('[data-gallery-thumbs]');
    if (moreBtn && thumbList) {
      thumbList.classList.add('is-scrollable');
      moreBtn.addEventListener('click', function () {
        thumbList.scrollBy({ top: 230, behavior: 'smooth' });
      });
    }

    /* ── Gallery: mobile horizontal drag/swipe on thumb strip ──
       Native overflow scroll often fails when the gesture starts on a
       <button>; axis-locked pointer/touch drag keeps swipe reliable. */
    if (thumbList) {
      var drag = {
        active: false,
        pointerId: null,
        startX: 0,
        startY: 0,
        startScroll: 0,
        moved: false,
        isHoriz: null
      };
      var dragMq = window.matchMedia('(max-width: 989px)');

      function endThumbDrag() {
        if (!drag.active) return;
        if (drag.pointerId !== null && thumbList.releasePointerCapture) {
          try { thumbList.releasePointerCapture(drag.pointerId); } catch (err) { /* ignore */ }
        }
        drag.active = false;
        drag.pointerId = null;
        drag.isHoriz = null;
        thumbList.classList.remove('is-dragging');
        thumbDragMoved = drag.moved;
        if (thumbDragMoved) {
          window.setTimeout(function () { thumbDragMoved = false; }, 0);
        }
      }

      thumbList.addEventListener('pointerdown', function (e) {
        if (!dragMq.matches) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        drag.active = true;
        drag.pointerId = e.pointerId;
        drag.startX = e.clientX;
        drag.startY = e.clientY;
        drag.startScroll = thumbList.scrollLeft;
        drag.moved = false;
        drag.isHoriz = null;
      });

      thumbList.addEventListener('pointermove', function (e) {
        if (!drag.active || e.pointerId !== drag.pointerId) return;

        var dx = e.clientX - drag.startX;
        var dy = e.clientY - drag.startY;

        if (drag.isHoriz === null) {
          /* Ignore click jitter; only lock axis after a real gesture */
          if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
          drag.isHoriz = Math.abs(dx) > Math.abs(dy);
          if (!drag.isHoriz) {
            endThumbDrag();
            return;
          }
          thumbList.classList.add('is-dragging');
          if (thumbList.setPointerCapture) {
            thumbList.setPointerCapture(e.pointerId);
          }
        }

        if (!drag.isHoriz) return;
        drag.moved = true;
        thumbList.scrollLeft = drag.startScroll - dx;
        e.preventDefault();
      }, { passive: false });

      thumbList.addEventListener('pointerup', endThumbDrag);
      thumbList.addEventListener('pointercancel', endThumbDrag);
    }

    /* ── Quantity stepper ── */
    var qtyInput = main.querySelector('[data-quantity-input]');
    var minusBtn = main.querySelector('[data-quantity-minus]');
    var plusBtn = main.querySelector('[data-quantity-plus]');

    function clampQty() {
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      qtyInput.value = v;
      return v;
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', clampQty);
      if (minusBtn) minusBtn.addEventListener('click', function () {
        qtyInput.value = Math.max(1, clampQty() - 1);
      });
      if (plusBtn) plusBtn.addEventListener('click', function () {
        qtyInput.value = clampQty() + 1;
      });
    }

    /* ── Add to cart (AJAX) ── */
    var form = main.querySelector('[data-product-form]');
    var addBtn = main.querySelector('[data-add-to-cart]');
    var addBtnText = main.querySelector('[data-add-to-cart-text]');

    function addToCart() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: parseInt(form.querySelector('[name="id"]').value, 10),
          quantity: clampQty()
        })
      }).then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw e; });
        return res.json();
      });
    }

    if (form && addBtn) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;

        var originalText = addBtnText.textContent;
        addBtn.disabled = true;
        addBtnText.textContent = addBtn.dataset.addingText || '…';

        addToCart()
          .then(function (item) {
            addBtnText.textContent = addBtn.dataset.addedText || '✓';
            setTimeout(function () {
              addBtnText.textContent = originalText;
              addBtn.disabled = false;
            }, 1600);

            if (window.MandarinCart) {
              window.MandarinCart.notifyAdded(item);
            }
          })
          .catch(function (err) {
            addBtnText.textContent = (err && err.description) || 'Error';
            setTimeout(function () {
              addBtnText.textContent = originalText;
              addBtn.disabled = false;
            }, 2400);
          });
      });
    }

    /* ── Buy it now: add to cart, then straight to checkout ── */
    var buyNowBtn = main.querySelector('[data-buy-now]');
    if (buyNowBtn && form) {
      buyNowBtn.addEventListener('click', function () {
        buyNowBtn.disabled = true;
        addToCart()
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () { buyNowBtn.disabled = false; });
      });
    }

    /* ── Accordion (What's Included / Materials & Care / Shipping & Returns) ── */
    main.querySelectorAll('[data-accordion-item]').forEach(function (item) {
      var toggle = item.querySelector('[data-accordion-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
